import React from "react";
import { Helmet } from "react-helmet";
// import FarmersSection from "./FarmersSection";
import Footer from "../../components/common/Footer";
import ProductShowcase from "../../components/common/ProductShowcase";
import ProductsSection from "../UtpannProduction/ProductsSection";
import TestimonialPage from "../PressReleaseGallery/TestimonialSection";

const ProductDetails2 = () => {
  const fertilizerData = {
    title: "Utpann GardenNest",
    category: "Fermented Organic Manure (FOM)",
    image: "/assets/Product/img2.png", // Image path as per your project
    description:
      "GardenNest is a premium organic manure designed to nourish your plants naturally and sustainably. It enriches the soil with essential nutrients, improving growth, flowering, and overall plant health. Perfect for home gardens, pots, and urban greenery, GardenNest brings the joy of thriving plants to every space.",
    price: "599",
    priceNote: "Per 5 kg Pack (amazon.in) (Inc GST)",
    recommendations: ["All Plants", "Home Garden & Pots", "Vegetables"],
    specsTitle: "FCO-1985 Technical Specifications :",
    specs: [
      { label: "Moisture% by weight maximum", value: "30-70%" },
      {
        label: "Particle Size",
        value: "Minimum 90% Material Should Pass through 4.0mm IS sieve",
      },
      { label: "Total Organic Carbon minimum", value: "12-14%" },
      { label: "pH", value: "6.0-8.4" },
      { label: "Electrical Conductivity", value: "Not more than 4.0" },
      { label: "Pathogens", value: "Nil" },
    ],
    packaging: [
      { label: "Bulk Bags", value: "1000kg FIBC" },
      { label: "Standard Bags", value: "5kg" },
      { label: "Containers", value: "20ft & 40ft available" },
      { label: "Minimum Order", value: "1 metric ton" },
      { label: "Custom Packaging", value: "Available on request" },
    ],
    benefits: [
      "Carbon Enhancer – Builds soil organic carbon and long-term fertility",
      "Better Soil Structure – Improves aeration and water-holding capacity",
      "Microbial Boost – Activates beneficial soil microbes",
      "Balanced Nutrition – Slow-release nutrients for steady crop growth",
    ],
  };
  return (
    <>
      <Helmet>
        <title>
          Utpann Production - Organic Bio-Fertilizer & Kesari Phos Products |
          Gujarat
        </title>
        <meta
          name="description"
          content="Utpann Production offers premium organic bio-fertilizers including Kesari Phos variants. 50k+ annual volume, 15+ manufacturing partners serving sustainable farming across Gujarat, India."
        />
        <meta
          property="og:title"
          content="Utpann Production - Organic Bio-Fertilizer & Kesari Phos Products | Gujarat"
        />
        <meta
          property="og:description"
          content="Utpann Production offers premium organic bio-fertilizers including Kesari Phos variants. 50k+ annual volume, 15+ manufacturing partners serving sustainable farming across Gujarat, India."
        />
      </Helmet>

      <main>
        <ProductShowcase productData={fertilizerData} />
        <div className="relative ">
          {/* Product Image Placeholder */}
          <img
            src="/assets/Product/Soil.png"
            alt={"Soil"}
            className="w-full h-auto object-contain"
          />
        </div>
        <ProductsSection />
        {/* <FarmersSection /> */}
        <TestimonialPage />
        <Footer />
      </main>
    </>
  );
};

export default ProductDetails2;
